import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import {Form, FormGroup, Label, Input} from 'reactstrap';
import classnames from 'classnames';
import { ButtonWithLoader } from '../../../core';
import { store } from '../../../store';
import { setOnboardingKycContactDetails } from "../../../actions";

class KycCompleted extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
    };

    this.updateKycContact = this.updateKycContact.bind(this);
  }
  componentDidMount() {
    this.setState({
      email: store.getState().onboarding && store.getState().onboarding.kycDetails ? store.getState().onboarding.kycDetails.email : '',
      phoneNumber: store.getState().onboarding && store.getState().onboarding.kycDetails ? store.getState().onboarding.kycDetails.mobile : '',
    })
  }

  getSnapshotBeforeUpdate() {
    return{
      email: store.getState().onboarding && store.getState().onboarding.kycDetails ? store.getState().onboarding.kycDetails.email : '',
      phoneNumber: store.getState().onboarding && store.getState().onboarding.kycDetails ? store.getState().onboarding.kycDetails.mobile : '',
    }
  }

  updateKycContact(e) {
    e.preventDefault();
    store.dispatch(setOnboardingKycContactDetails(this.state));

    this.setState({
      submitting: true
    });

    //TODO: Which API Call happens here?

    if (this.props.checkFor === 'BSE_SETUP'){
        this.props.goToBank("KYC_COMPLETE");
        return;
    }
    this.props.onComplete(this.props.stepName, {});
  }

  render() {
    return (
      <div className="kyc-completed">
        <Row className="justify-content-center">
          <Col xs={12} md={6} lg={5}>
            <h2 className="font-weight-semi-bold font-size-triple">
              You're KYC ready!
            </h2>
            <p>Would you like to update your KYC email and phone number?</p>
          </Col>
          <Col xs={12} md={6} lg={5}>
            <Form className="login-form" onSubmit={this.updateKycContact}>
              <FormGroup>
                <Label for="pan" 
                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.email })} >
                        Email
                </Label>

                <Input type="email" 
                       name="pan" 
                       id="pan" 
                       className="form-control font-weight-semi-bold text-lowercase"
                       placeholder="Email" 
                       onChange={e => this.setState({email: e.target.value})}
                       value={this.state.email}
                       />
              </FormGroup>

              <FormGroup>
                <Label for="phoneNumber" 
                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.phoneNumber })} >
                        Phone Number
                </Label>

                <Input type="text" 
                       name="phoneNumber" 
                       id="phoneNumber" 
                       className="form-control font-weight-semi-bold"
                       placeholder="Phone Number" 
                       onChange={e => this.setState({phoneNumber: e.target.value})}
                       value={this.state.phoneNumber}
                       />
              </FormGroup>

              <FormGroup className="cta-block">
                <ButtonWithLoader 
                      text="Save & continue" 
                      isLoading={this.state.isSubmitting} 
                      color="primary" 
                      className="w-100"
                      disabled={!this.state.email && !this.state.phoneNumber}
                      />
              </FormGroup>
            </Form>  
          </Col>
        </Row>
      </div>
    );
  }
}

export default KycCompleted;